import styled from "styled-components";
import { colorBrandPrimary, marginHeight } from "../../../../global.style";
import { media } from "../../../../layouts/utils";
import {
  TituloH1 as TituloPrincipal,
  Sorriso as IconSorriso,
} from "../../../../components/TituloSorriso/styles";

export const Wrapper = styled.div`
  background-color: ${colorBrandPrimary.marine};
  width: 100%;
  padding-bottom: 20px;
`;

export const Title = styled(TituloPrincipal)`
  color: #fffff0;
  padding-top: ${marginHeight};
  font-size: 48px;
  ${media.desktop`
    padding-bottom: 15px;
    font-size: 32px;
  `}
`;

export const Sorriso = styled(IconSorriso)`
  margin-bottom: 0;
  filter: ${(props) => props.filter && `brightness(100)`};
`;
